import TrackPlayer from '../../AudiobooksContainer/TrackPlayer/TrackPlayer';
import ArrowRight from "../../../assets/icons/arrow_right.png";

const MusicSection = (props) => {

    return (
        <section>
            <a href="/musics" className="section-title-link">
                <h2>Musiques</h2> 
                <img src={ArrowRight} alt="arrow right" />
            </a>
            <h3>Sélection d'oeuvres récentes</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            {props.trackSelection.map((track, i) => (
                <TrackPlayer 
                currentTrack={track}
                key={track.title}
                activeTrackId={props.activeTrackId}
                setActiveTrackId={props.setActiveTrackId}
                onTrackEnd={props.onTrackEnd}
                />
            ))}
            </div>
        </section>
    )
}

export default MusicSection;